import api from "plus/api";
import {
  SEAL_EXTRA_FILE_TYPES,
  SEAL_PURPOSE_OPTIONS,
  SEAL_QUALIFICATION_NAME_OPTIONS,
} from "../config";

/**
 * 公章资质（SEAL_QUALIFICATION）工单：状态、校验与载荷构建
 * 合并到入口页 write.vue，由 FormSeal 仅负责模板展示
 */
export default {
  data() {
    return {
      sealApplicantUsers: [],
      sealArchive: {
        email: "",
        workLocation: "",
      },
      sealUsageDateRange: null,
      sealNeedCompanySeal: null,
      sealSealEntityId: "",
      sealStampAttachments: [],
      sealNeedQualification: null,
      sealQualificationEntityId: "",
      sealQualificationType: "",
      sealNeedLegalPersonInfo: null,
      sealIsTakenOut: null,
      sealPurpose: "",
      sealUsageDescription: "",
      companyEntityOptions: [],
      sealWorkLocationHr: null,
      sealHrError: "",
      sealArchiveLoading: false,
      sealUploadLoading: false,
      sealExtraFileTypes: SEAL_EXTRA_FILE_TYPES,
      sealQualificationNameOptions: SEAL_QUALIFICATION_NAME_OPTIONS,
      sealPurposeOptions: SEAL_PURPOSE_OPTIONS,
    };
  },
  computed: {
    sealShowNeedLegalBlock() {
      return this.sealNeedCompanySeal || this.sealNeedQualification;
    },
    sealLegalPersonNamesJoined() {
      const names = [];
      if (this.sealNeedCompanySeal && this.sealSealEntityId) {
        names.push(this.pickLegalPersonName(this.sealSealEntityId));
      }
      if (this.sealNeedQualification && this.sealQualificationEntityId) {
        names.push(this.pickLegalPersonName(this.sealQualificationEntityId));
      }
      return [...new Set(names)].join("、");
    },
    sealLegalPersonFlowText() {
      const n = this.sealLegalPersonNamesJoined;
      return n ? `法人 ${n} 会加入审核流程` : "";
    },
    sealHrReady() {
      return (
        !this.sealHrError &&
        this.sealWorkLocationHr &&
        !!this.sealWorkLocationHr.realName
      );
    },
    sealApprovalPreviewNodes() {
      const nodes = [
        { title: "直属上级审批", sub: "提交人直接上级" },
        { title: "法务审批", sub: "法务" },
        { title: "风控审批", sub: "风控" },
      ];
      if (this.sealNeedLegalPersonInfo && this.sealNeedCompanySeal) {
        nodes.push({
          title: "公章法人审批",
          sub: this.pickLegalPersonName(this.sealSealEntityId),
        });
      }
      if (this.sealNeedLegalPersonInfo && this.sealNeedQualification) {
        nodes.push({
          title: "资质法人审批",
          sub: this.pickLegalPersonName(this.sealQualificationEntityId),
        });
      }
      const hrName =
        (this.sealWorkLocationHr && this.sealWorkLocationHr.realName) || "HR";
      nodes.push({
        title: "所属地HR审批",
        sub: hrName,
      });
      return nodes;
    },
  },
  watch: {
    sealShowNeedLegalBlock(val, oldVal) {
      if (!val) {
        this.sealNeedLegalPersonInfo = null;
      } else if (!oldVal && val) {
        this.sealNeedLegalPersonInfo = null;
      }
    },
    sealNeedCompanySeal(val) {
      if (!val) {
        this.sealSealEntityId = "";
        this.sealStampAttachments = [];
      }
    },
    sealNeedQualification(val) {
      if (!val) {
        this.sealQualificationEntityId = "";
        this.sealQualificationType = "";
      }
    },
  },
  methods: {
    resetSealQualificationState() {
      this.sealApplicantUsers = [];
      this.sealArchive = { email: "", workLocation: "" };
      this.sealUsageDateRange = null;
      this.sealNeedCompanySeal = null;
      this.sealSealEntityId = "";
      this.sealStampAttachments = [];
      this.sealNeedQualification = null;
      this.sealQualificationEntityId = "";
      this.sealQualificationType = "";
      this.sealNeedLegalPersonInfo = null;
      this.sealIsTakenOut = null;
      this.sealPurpose = "";
      this.sealUsageDescription = "";
      this.companyEntityOptions = [];
      this.sealWorkLocationHr = null;
      this.sealHrError = "";
      this.sealArchiveLoading = false;
      this.sealUploadLoading = false;
    },
    async bootstrapSealQualificationForm() {
      this.resetSealQualificationState();
      await this.loadCompanyEntityOptions();
      const today = this.formatDateYmd(new Date());
      this.sealUsageDateRange = null;
      this.sealPurpose = "";
      this.$nextTick(() => {
        this.prefillSealApplicantWithCurrentUser();
      });
    },
    formatDateYmd(d) {
      const y = d.getFullYear();
      const m = `${d.getMonth() + 1}`.padStart(2, "0");
      const day = `${d.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    prefillSealApplicantWithCurrentUser() {
      const uid =
        this.$store.state.userInfo && this.$store.state.userInfo.userId;
      if (!uid || !this.allUserOptions.length) {
        return;
      }
      const u = this.allUserOptions.find((x) => x.userId === uid);
      if (u) {
        this.sealApplicantUsers = [u];
        this.onSealApplicantChange();
      }
    },
    onSealUploadLoading(val) {
      this.sealUploadLoading = val;
    },
    async loadCompanyEntityOptions() {
      try {
        const res = await api.work.getCompanyEntityDropdown({});
        const list = (res.data && res.data.data) || [];
        this.companyEntityOptions = Array.isArray(list) ? list : [];
      } catch (e) {
        this.companyEntityOptions = [];
        this.$message.error("公司主体列表加载失败");
      }
    },
    async onSealApplicantChange() {
      this.sealArchive = { email: "", workLocation: "" };
      this.sealWorkLocationHr = null;
      this.sealHrError = "";
      if (!this.sealApplicantUsers.length) {
        return;
      }
      const user = this.sealApplicantUsers[0];
      const bid = user.beisenUserId;
      if (bid == null || bid === "") {
        this.sealHrError = "申请人北森ID为空，无法获取档案与承接人";
        return;
      }
      this.sealArchiveLoading = true;
      try {
        const res = await api.work.getUserArchive({ beisenUserId: bid });
        if (!res.data.success || !res.data.data) {
          throw new Error(res.data.msg || "获取用户档案失败");
        }
        const arc = res.data.data;
        this.sealArchive.email = arc.email || "";
        this.sealArchive.workLocation = arc.baseAddress || "";
        const wl = (this.sealArchive.workLocation || "").trim();
        if (!wl) {
          this.sealHrError = "档案中工作地点为空，无法匹配承接人";
          return;
        }
        const hrRes = await api.work.queryWorkLocationHr({
          workLocation: wl,
        });
        if (!hrRes.data.success || !hrRes.data.data) {
          this.sealHrError = hrRes.data.msg || "按工作地点查询HR失败";
          return;
        }
        const hr = hrRes.data.data;
        if (!hr || !hr.realName) {
          this.sealHrError = "未获取到有效的HR承接人信息";
          return;
        }
        this.sealWorkLocationHr = hr;
        this.sealHrError = "";
      } catch (e) {
        this.sealHrError = (e && e.message) || "获取档案或承接人失败";
        this.sealWorkLocationHr = null;
      } finally {
        this.sealArchiveLoading = false;
      }
    },
    entityRowId(ent) {
      if (!ent) {
        return undefined;
      }
      if (ent.id != null && ent.id !== "") {
        return ent.id;
      }
      return ent.companyEntityId;
    },
    entityById(id) {
      if (id === null || id === undefined || id === "") {
        return null;
      }
      return this.companyEntityOptions.find(
        (e) =>
          this.entityRowId(e) === id ||
          String(this.entityRowId(e)) === String(id),
      );
    },
    pickLegalPersonName(id) {
      if (!id) return undefined;
      const ent = this.entityById(id);
      if (!ent) return undefined;
      const n = ent.legalPersonName || "-";
      if (n) return n;
    },
    hasLegalPersonForEntity(id) {
      const ent = this.entityById(id);
      if (!ent) return false;
      const lp = ent.legalPersonId;
      if (lp === null || lp === undefined || lp === "") {
        return false;
      }
      if (typeof lp === "number" && !Number.isFinite(lp)) {
        return false;
      }
      return true;
    },
    dayStartIsoFromYmd(ymd) {
      const [y, m, d] = ymd.split("-").map((x) => parseInt(x, 10));
      const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
      return dt.toISOString();
    },
    dayEndIsoFromYmd(ymd) {
      const [y, m, d] = ymd.split("-").map((x) => parseInt(x, 10));
      const dt = new Date(y, m - 1, d, 23, 59, 59, 999);
      return dt.toISOString();
    },
    validateSealForm() {
      if (!this.sealApplicantUsers.length) {
        return "请选择申请人";
      }
      if (this.sealHrError || !this.sealHrReady) {
        return this.sealHrError || "承接人信息未就绪，无法提交";
      }
      if (
        !this.sealUsageDateRange ||
        this.sealUsageDateRange.length !== 2 ||
        !this.sealUsageDateRange[0] ||
        !this.sealUsageDateRange[1]
      ) {
        return "请选择使用时间";
      }
      if (
        this.sealNeedCompanySeal !== true &&
        this.sealNeedCompanySeal !== false
      ) {
        return "请选择是否需要公司公章";
      }
      if (
        this.sealNeedQualification !== true &&
        this.sealNeedQualification !== false
      ) {
        return "请选择是否需要公司资质";
      }
      if (this.sealNeedCompanySeal) {
        if (!this.sealSealEntityId) {
          return "请选择公章对应的主体";
        }
        if (!this.sealStampAttachments.length) {
          return "请上传公章盖章附件";
        }
      }
      if (this.sealNeedQualification) {
        if (!this.sealQualificationEntityId) {
          return "请选择资质对应的主体";
        }
        if (!this.sealQualificationType) {
          return "请选择资质名称";
        }
      }
      if (this.sealShowNeedLegalBlock) {
        if (
          this.sealNeedLegalPersonInfo !== true &&
          this.sealNeedLegalPersonInfo !== false
        ) {
          return "请选择是否需要法人信息";
        }
        if (this.sealNeedLegalPersonInfo) {
          if (
            this.sealNeedCompanySeal &&
            !this.hasLegalPersonForEntity(this.sealSealEntityId)
          ) {
            return "公章所选主体缺少法人信息，无法提交";
          }
          if (
            this.sealNeedQualification &&
            !this.hasLegalPersonForEntity(this.sealQualificationEntityId)
          ) {
            return "资质所选主体缺少法人信息，无法提交";
          }
        }
      }
      if (this.sealIsTakenOut !== true && this.sealIsTakenOut !== false) {
        return "请选择公章或资质是否外带";
      }
      if (!this.sealPurpose) {
        return "请选择用途";
      }
      if (!this.sealUsageDescription) {
        return "请填写具体使用说明";
      }
      return "";
    },
    buildSealQualificationPayload() {
      const user = this.sealApplicantUsers[0];
      const sealEnt = this.entityById(this.sealSealEntityId);
      const qualEnt = this.entityById(this.sealQualificationEntityId);
      const [startYmd, endYmd] = this.sealUsageDateRange || [];
      return {
        applicantId: user.userId != null ? String(user.userId) : "",
        applicantBeisenUserId: user.beisenUserId,
        applicantName: user.userName,
        applicantEmail: this.sealArchive.email,
        workLocation: this.sealArchive.workLocation,
        startTime: this.dayStartIsoFromYmd(startYmd),
        endTime: this.dayEndIsoFromYmd(endYmd),
        needCompanySeal: this.sealNeedCompanySeal,
        sealEntityId: this.sealNeedCompanySeal
          ? String(this.sealSealEntityId || "")
          : "",
        sealEntityName: this.sealNeedCompanySeal
          ? (sealEnt && (sealEnt.companyName || "")) || ""
          : "",
        attachments: this.sealNeedCompanySeal
          ? this.sealStampAttachments.map((a) => ({
              attachmentType: a.attachmentType || "FILE",
              appendisUrl: a.appendisUrl,
            }))
          : [],
        needQualification: this.sealNeedQualification,
        qualificationEntityId: this.sealNeedQualification
          ? String(this.sealQualificationEntityId || "")
          : "",
        qualificationEntityName: this.sealNeedQualification
          ? (qualEnt && (qualEnt.companyName || "")) || ""
          : "",
        qualificationType: this.sealNeedQualification
          ? this.sealQualificationType
          : "",
        needLegalPersonInfo: this.sealShowNeedLegalBlock
          ? this.sealNeedLegalPersonInfo
          : false,
        isTakenOut: this.sealIsTakenOut,
        purpose: this.sealPurpose,
        usageDescription: this.sealUsageDescription || "",
      };
    },
  },
};
